// extracted by mini-css-extract-plugin
module.exports = {"newsCard":"styles_newsCard__1soGo"};